module.exports = __webpack_public_path__ + "img/chat-live2d-bg.f011ec62.png";